module.exports = {"150426100":"乌丹镇","150426101":"乌敦套海镇","150426102":"五分地镇","150426103":"桥头镇","150426104":"广德公镇","150426105":"梧桐花镇","150426106":"海拉苏镇","150426107":"亿合公镇","150426200":"解放营子乡","150426201":"阿什罕苏木","150426202":"新苏莫苏木","150426203":"白音套海苏木","150426204":"毛山东乡","150426205":"格日僧苏木","150426400":"玉龙工业园区","150426402":"紫城街道","150426403":"全宁街道"}


//////////////////
// WEBPACK FOOTER
// ./src/town/150426.json
// module id = 511
// module chunks = 0